/**
 * 模組名稱：Error404
 * 模組說明：錯誤頁面404
 * @module Error404.jsx
 */

// ----- import from local modules -----
import { React, BaseComponent } from '../../components/BaseComponent';

// ----- import css -----
import './style.scss';

export default class Error404 extends BaseComponent {
    direct() {
        window.location = this.getUrl('/');
    }

    render() {
        return (
            <div className="page404">
                <div>404</div>
                <div>頁面不存在</div>
                <div>
                    <button
                        type="button"
                        onClick={this.direct.bind(this)}
                    >
                        {'回首頁'}
                    </button>
                </div>
            </div>
        );
    }
}
